import { render, staticRenderFns } from "./StudentResulView.vue?vue&type=template&id=9c1acfd8&scoped=true&"
import script from "./StudentResulView.vue?vue&type=script&lang=js&"
export * from "./StudentResulView.vue?vue&type=script&lang=js&"
import style0 from "./StudentResulView.vue?vue&type=style&index=0&id=9c1acfd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1acfd8",
  null
  
)

export default component.exports